import { AnalyticsAction, AnalyticsActionSubject } from '../../types';
import { BaseInvitePeopleAnalytics } from '../../analytics/BaseInvitePeopleAnalytics';

type Attributes = {
	products: string[];
	invitees: number;
};

export class InviteSuccessContentAnalytics extends BaseInvitePeopleAnalytics {
	driveMultiProductsSuccessModalViewed(attributes: Attributes) {
		this.fireScreen({
			name: AnalyticsActionSubject.DRIVE_MULTI_PRODUCTS_SUCCESS_MODAL,
			attributes,
		});
	}

	productCheckboxChecked(product: string) {
		this.fireUI({
			actionSubject: AnalyticsActionSubject.PRODUCT_CHECKBOX,
			action: AnalyticsAction.CHECKED,
			actionSubjectId: AnalyticsActionSubject.DRIVE_MULTI_PRODUCTS_SUCCESS_MODAL,
			attributes: { product },
		});
	}

	productCheckboxUnchecked(product: string) {
		this.fireUI({
			actionSubject: AnalyticsActionSubject.PRODUCT_CHECKBOX,
			action: AnalyticsAction.UNCHECKED,
			actionSubjectId: AnalyticsActionSubject.DRIVE_MULTI_PRODUCTS_SUCCESS_MODAL,
			attributes: { product },
		});
	}
}
